module.exports = __webpack_public_path__ + "img/CloudCanvas.82fd9ce.svg";